export const GET_PROMOS_SUCCESS = 'GET_PROMOS_SUCCESS';
export const GET_PROMOS_FAIL = 'GET_PROMOS_FAIL';
export const GET_PROMO_ITEM_SUCCESS = 'GET_PROMO_ITEM_SUCCESS';
export const SET_PROMO_IS_FETCHING = 'SET_PROMO_IS_FETCHING';
export const RESET_PROMOS = 'RESET_PROMOS';
